import * as React from 'react';
import { getOpenAIResponse } from './aiservice'
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Mood from './Step1';
import Genre from './Step2';
import Actor from './Step3';
import Language from './Step4';
import Watchtime from './Step5';
import Results from './Results';
import MovieContext from './context/store';

export default function PaginationControlled() {
  const [page, setPage] = React.useState(1);
  const [message,setMessage] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const finalContext = React.useContext(MovieContext);

  const movieMessage = React.useState([]);
  const BASE_URL = 'https://api.themoviedb.org/3';
  const MOVIE_API_KEY = process.env.REACT_APP_MOVIE_DB_API_KEY;
  

  const handleChange = (event,value) => {
    setPage(value);
  };

  const handleClick = () => {
    setPage((page) => parseInt(page) + 1);
  }

  const searchByTitle = async (title, fallbackPreviewLink) => {
    try {
      const encodedTitle = encodeURIComponent(title);
      const response = await fetch(
        `${BASE_URL}/search/multi?api_key=${MOVIE_API_KEY}&query=${encodedTitle}&language=en-US`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const result = data.results[0];
        return {
          title: result.title || result.name,
          overview: result.overview,
          previewLink: fallbackPreviewLink,
          poster: result.poster_path ? `https://image.tmdb.org/t/p/w500${result.poster_path}` : null,
        };
      }
    } catch (error) {
      console.error('Error searching TMDB:', error);
    }

    return null;
  };
  React.useEffect(() => {
    if (page === 6) {
      const fetchAI = async () => {
        setLoading(true);
        
        try {
            const content = await getOpenAIResponse(
                `You are a movie recommendation engine. Based on the following user preferences, recommend 5 unique Netflix titles tailored to the user. Also add tv series with movies. Each result should be different based on genre, mood, actor, language, and watchtime. Return a JSON array with:
              
              - title (string)
              - previewLink (Netflix URL)
              - director (string)
              - description (1–2 sentences)
              
              User preferences:
              - Mood: ${finalContext.mood}
              - Genre: ${finalContext.genre}
              - Favorite actor: ${finalContext.actor}
              - Language: ${finalContext.language}
              - Desired watchtime: ${finalContext.Watchtime}
              
              Avoid generic or overly popular movies unless they directly match the user’s mood or preferences. Respond with a JSON array. Use https://www.netflix.com/search?q=<title> for example https://www.netflix.com/search?q=Sleepless+in+Seattle
 as the previewLink to increase the chance of a valid link.`
              );
              
          const parsed = JSON.parse(content);
         // setMessage(parsed);
            // Run TMDB search for each result
          const enrichedResults = await Promise.all(
            parsed.map((item) =>
              searchByTitle(item.title, item.previewLink)
            )
          );

          const filtered = enrichedResults.filter((r) => r !== null);
          setMessage(filtered);
          

        } catch (e) {
          console.error("Failed to parse AI response:", e);
        } finally {
          setLoading(false);
        }
      };
      fetchAI();
    }
  }, [page, finalContext]);
  

  

  return (
    <Stack style={{display:"flex",justifyContent:"center",alignItems:"center"}} spacing={2}>
        <Pagination count={5} page={page} onChange={handleChange} />
      <Typography style={{fontSize:"16px",fontWeight:"bold"}}>{page === 6 ? <h2>Results</h2> : `Step: ${page}`}</Typography>
      {page === 1 && <Mood getdata={() => handleClick()}/>}
      {page === 2 && <Genre getdata={() => handleClick()}/>}
      {page === 3 && <Actor getdata={() => handleClick()}/>}
      {page === 4 && <Language getdata={() => handleClick()}/>}
      {page === 5 && <Watchtime getdata={() => handleClick()}/>}
      {page === 6 && (
  loading ? <CircularProgress style={{ marginTop: "20px" }} /> : <Results movieData={message} />
)}
    </Stack>
  );
}